import React from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Mountain, LogOut, User as UserIcon } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Button } from "./ui/button";

const NavItem = ({ to, label, gated, subscribed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname === to;
  const handleClick = (e) => {
    if (gated && !subscribed) {
      e.preventDefault();
      navigate("/pricing?gated=1");
    }
  };
  return (
    <NavLink
      to={to}
      onClick={handleClick}
      data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
      className={`text-sm font-medium tracking-tight px-3 py-2 rounded-md transition-colors ${
        isActive ? "text-[#314A3E] bg-[#EAE5D9]" : "text-stone-700 hover:text-[#314A3E] hover:bg-[#F0EBE1]"
      }`}
    >
      {label}
    </NavLink>
  );
};

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-[#F7F5F0]/85 backdrop-blur-xl border-b border-[#E2DCD0]/70">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <div className="w-9 h-9 rounded-lg bg-[#314A3E] flex items-center justify-center group-hover:rotate-6 transition-transform">
            <Mountain className="w-5 h-5 text-[#EAE5D9]" />
          </div>
          <div className="leading-tight">
            <div className="font-bold text-[15px] tracking-tight text-[#292524]" style={{ fontFamily: "Outfit" }}>Kootenay Home Pros</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-stone-500">Kootenay Region · BC</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {user?.subscription_active && <NavItem to="/directory" label="Directory" />}
          {user?.subscription_active && <NavItem to="/projects" label="Projects" />}
          <NavItem to="/pricing" label="Pricing" />
          {user && <NavItem to="/dashboard" label="Dashboard" />}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#EAE5D9]">
                <UserIcon className="w-3.5 h-3.5 text-[#314A3E]" />
                <span className="text-xs font-semibold text-[#314A3E]" data-testid="user-name">{user.name}</span>
              </div>
              <Button
                data-testid="logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                variant="outline"
                size="sm"
                className="border-[#E2DCD0] hover:bg-[#F0EBE1]"
              >
                <LogOut className="w-3.5 h-3.5 mr-1.5" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button data-testid="header-login-btn" onClick={() => navigate("/login")} variant="ghost" size="sm">Login</Button>
              <Button data-testid="header-signup-btn" onClick={() => navigate("/signup")} size="sm" className="bg-[#314A3E] hover:bg-[#243a30] text-white">Get Started</Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
